module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN-S"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("History is a guide to navigation in perilous times. History is who we are and why we are the way we are.")]), _vm._v(" "), _c('div', {
    staticClass: "SPACE"
  }, [_c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—David McCullough")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0